import React, { useCallback, useContext, useEffect, useState, useRef } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import WebGLContext, { IChartData, IBubbleDetails } from "./WebGlContext";
import { getTagData } from "api/tags";
import { getExpressionData } from "api/expression";
import {
  getNotes,
  updateBubblePosition as apiUpdateBubblePosition,
  getLabelsMeta,
  updateLabelPos,
  getAllWidgets,
  getWidget,
  updateWidgetPosition,
  deleteWidget,
  deleteBubble,
  deleteLabel,
  deleteNote,
  getWidgetsData,
  getWidgetsMeta,
  createNote as crateNoteApiCall
} from "api/unity";
import { getFileByUniqueId } from "api/fileManager";
import { getPointCloudImages } from "api/pointCloud";
import { usePins } from "hooks/usePins";
import useUnity from "hooks/UseUnity";
import { equipmentProps, unitsProps } from "types/tagexpressiontypes";
import {
  SplashScreen,
  Pin,
  Note,
  Label,
  Widget,
  ChartsContainer,
  PreviewFiles,
  MinifiedMenu,
} from "processhub-components-lib";
import AiChat from "components/AiChat/AiChat";
import UnityMeasurements from "components/UnityMeasurements/UnityMeasurements";
import findItemByUrl from "./utils/findItemByUrl";
import { getData } from "./domain/getBubbleNotesUnitsEquipments";
import useData from "hooks/useData";
import { TagExpressionHandler } from "./domain/GetUnitEquipmentforTagsExpressions";
import { ModalContext } from "hooks/ModalProvider";
import allHooks from "hooks";
import unityChartsContainerConfig from "config/unity/unityChartsContainerConfig'";
import unityWidgetConfig from "config/unity/unityWidgetConfig";
import noteFormConfig from "config/unity/noteFormConfig";
import labelConfig from "config/unity/LabelConfig";
import getFileExtension from "utilities/getFileExtension";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import findItemByUUID from "utilities/findItemByUuid";
import getItemByIndex from "./utils/getItemByIndex";
import UnityMenu from "./UnityMenu/UnityMenu";
import { useUnityActions } from "hooks/unityActions";
import { useMeasurements } from "hooks/MeasurementsContext";
import { useAutoUpdateWidgets } from "hooks/useAutoupdateWidget";

const WebGL: React.FC = () => {
  function handleCacheControl(url: any) {
    if (url.match(/\.data/) || url.match(/\.bundle/)) {
      return "must-revalidate";
    }
    if (url.match(/\.mp4/) || url.match(/\.wav/)) {
      return "immutable";
    }
    return "no-store";
  }
  const {
    unityProvider,
    sendMessage,
    isLoaded,
  } = useUnityContext({
    loaderUrl: window.vuplex ? "" : "Build/Unity/WebGL.loader.js",
    dataUrl: window.vuplex ? "" : "Build/Unity/WebGL.data",
    frameworkUrl: window.vuplex ? "" : "Build/Unity/WebGL.framework.js",
    codeUrl: window.vuplex ? "" : "Build/Unity/WebGL.wasm",
    cacheControl: handleCacheControl,
    streamingAssetsUrl: window.vuplex ? "" : "Build/Unity/StreamingAssets",
  });
  const { unityPins, unpinAllWidgets } = usePins();
  const { TimelineShown, selectedPointCloudId, setSelectedPointCloudId } = useUnity();
  const { modalType } = useContext(ModalContext);
  const {
    minifiedMenuItems,
    addItemToPosition,
    minifiedImgPreviewData,
    updateLeftPanel,
    updateRightPanel,
    removeMinifiedTab,
    minifiedMenuOpen,
    setMenuVisibilityParams,
    menuVisibilityParams
  } = useMinifiedMenu();

  const {
    getEquipmentInfo,
    getTagsInfo,
    pastDate
  } = useData();

  const [chartData, setChartData] = useState<IChartData[] | null>(null);
  const [bubbleDetails, setBubbleDetails] = useState<IBubbleDetails | null>(
    null
  );
  const [rerenderBubble, setRenderBubble] = useState(false);
  const [bubbleModalOpen, setBubbleModalOpen] = useState(false);
  const [bubblePopUp, setBubblePopUp] = useState<any>(null);
  const [chartType, setChartType] = useState<any>(null);
  const [notePopup, setNotePopup] = useState<any>(null);
  const [popupNoteId, setNoteId] = useState<number | null>(null);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [popupBubbleId, setBubbleId] = useState<number | null>(null);
  const [rerenderBubbleData, setRenderBubbleData] = useState(false);
  const [LabelPopup, setLabelPopup] = useState<any>(null);
  const [popupLabelId, setLabelId] = useState<number | null>(null);
  const [LabelModalOpen, setLabelModalOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoader, setModalLoader] = useState(true);
  const [ticketTags, updateTicketTags] = useState<number[]>([]);
  const [showPins, setShowPins] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(
    "Loading data from the network"
  );
  const [allBubbles, setAllBubbles] = useState<any>(null);
  const [bubblesMeta, setBubblesMeta] = useState<any>(null);
  const [allLabels, setAllLabels] = useState<any>(null);
  const [equipments, setEquipments] = useState<equipmentProps[] | null>(null);
  const [units, setUnits] = useState<unitsProps[] | null>(null);
  const [allNotes, setAllNotes] = useState<any>(null);
  const [widgetData, setWidgetData] = useState({
    unitId: null,
    equipmentId: null,
    showEquipmentWidget: false,
    widgets: [],
    name: "",
    desc: "",
    x: 0,
    y: 0,
    z: 0
  });
  const [allWidgets, setAllWidgets] = useState<any>([]);
  const [widgetForBubbleId, setWidgetForBubbleId] = useState<number | null>(null);
  const [selectedWidget, setSelectedWidget] = useState<number | null>(null);
  interface bubbleAllDetailsProps {
    bubbletype: string;
    unitId: number | null;
    equipmentId: number | null;
  }

  const [showSideMenu, setShowMenu] = useState(false);
  const [showGraph, setShowGraph] = useState(false);
  const [bubbleAllDetails, setbubbleAllDetails] = useState<bubbleAllDetailsProps | null>(null);
  const [picturesDetails, setPicturesDetails] = useState<any[]>([]);
  const [rawPicUrl, setRawPicUrl] = useState<null | string>(null);
  const [pointCloudPicData, setPointCloudPicData] = useState<{ fileSrc: string, fileName: string, index: null | number }>({
    fileSrc: "",
    fileName: "",
    index: null
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pictureLoading, setPictureLoading] = useState(false);
  const [tagsIds, setTagsIds] = useState([]);
  const [expressionIds, setExpressionsIds] = useState([]);
  const [widgetCoordinates, setWidgetCoordinates] = useState<number[]>([]);
  const [widgetModalMode, setWidgetModalMode] = useState<'none' | 'create' | 'modify' | 'delete'>('none');
  const [widgetPositionUpdate, setWidgetPositionUpdate] = useState<any>(null);
  const [itemToDelete, setItemToDelete] = useState<{ item: string, id: number | null }>({ item: '', id: null });
  const [previewData, setPreviewData] = useState<any>({ uniqueId: '', fileName: '', data: '' });
  const {
    addPoint,
    setDistanceAndArea,
    setVolume,
    setValue,
    selectedTab,
    setSelectedFigure,
    updatePointCoordinates
  } = useMeasurements();
  const { editingMode, isMovementDisabled, setIsMovementDisabled } = useUnityActions();

  function sendBubbleData(reload: boolean) {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  }

  // useEffect(() => {
  //   if (noteInfo) {
  //     noteInfoRef.current = noteInfo;
  //     sendStateToUnity('SetButton', 'AddNote');
  //     setNoteInfo(null);
  //   }
  // }, [noteInfo]);

  useAutoUpdateWidgets();

  useEffect(() => {
    if (rawPicUrl === null) {
      setPointCloudPicData({ fileSrc: '', fileName: '', index: null });
    }
    if (picturesDetails.length > 0 && rawPicUrl !== null) {
      const currPicture = findItemByUrl(picturesDetails, rawPicUrl);
      if (currPicture) {
        setPointCloudPicData({ fileSrc: currPicture.item.url, fileName: currPicture.item.fileName, index: currPicture.index });
      }
    }
  }, [rawPicUrl, picturesDetails]);

  useEffect(() => {
    if (selectedWidget !== null) {
      const getWidgetData = async (id: number) => {
        const response = await getWidget(id);
        if (response.status === 200) {
          setWidgetData({ ...response.data, id });
          setWidgetModalMode('modify');
        }
        else {
          console.log('error fetching widget');
        }
      };
      getWidgetData(selectedWidget);
    }
  }, [selectedWidget]);

  useEffect(() => {
    if (window.vuplex) {
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [isMovementDisabled] });
      window.vuplex.postMessage(message);
    }
  }, [isMovementDisabled]);

  useEffect(() => {
    if (modalType === 'gantt' || modalType === 'settings') {
      setShowMenu(false);
    }
  }, [modalType]);

  useEffect(() => {
    if (widgetModalMode === 'none') {
      setIsMovementDisabled(0);
      const getWidgets = async () => {
        const response = await getAllWidgets();
        if (response.status === 200) {
          setAllWidgets(response.data);
        } else {
          //error handling will be here
        }
      };
      getWidgets();
      setSelectedWidget(null);
    } else {
      setIsMovementDisabled(1);
    }
  }, [widgetModalMode]);

  useEffect(() => {
    if (allWidgets.length > 0) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetList",
            arguments: [JSON.stringify(allWidgets)]
          }
        )
      );
    }
    getWidgetsInfo();
  }, [allWidgets]);

  function sendCanvasVisibility(state: number) {
    window.vuplex.postMessage(JSON.stringify({ object: "CanvasVisibility", type: "CanvasVisibility", method: "SetStatus", arguments: [state] }));
  }

  useEffect(() => {
    if (modalOpen || noteModalOpen || LabelModalOpen || bubbleModalOpen || isModalOpen || modalType !== '') {
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [1] });
      window.vuplex.postMessage(message);
      setMenuVisibilityParams({ left: false, right: false });
      if (window.vuplex) {
        sendCanvasVisibility(0);
      }
    }
    else {
      getWidgetsInfo();
      window.vuplex.postMessage(JSON.stringify({ object: "MainWidget", type: "ProcessHub.DynamicWidget.DynamicWidgetController", method: "SetWidgetList", arguments: [JSON.stringify(allWidgets)] }));
      const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [0] });
      window.vuplex.postMessage(message);
      setMenuVisibilityParams({ left: true, right: true });
      if (window.vuplex) {
        sendCanvasVisibility(1);
      }
    }
  }, [modalOpen, noteModalOpen, LabelModalOpen, bubbleModalOpen, isModalOpen]);

  useEffect(() => {
    if (window.vuplex) {
      (async () => {
        const data: any = await getData();
        setBubblesMeta(data.BubblesMeta);
        setAllBubbles(data.BubblesData);
        setAllNotes(data.Notes);
        setEquipments(data.Equipments);
        setUnits(data.Units);
        setAllLabels(data.LabelsMeta);

        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(allNotes)] }));
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
      })();
      getWidgetsInfo();
    }
  }, [window.vuplex, location.pathname]);

  const updateNotes = async () => {
    if (window.vuplex) {
      const notesResponse = await getNotes();
      if (notesResponse.status === 200) {
        setAllNotes(notesResponse.data);
      }
      window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(notesResponse.data)] }));
    }
  };

  const useDataFetcher = (ids: any, messageType: any, fetchDataFn: any) => {
    useEffect(() => {
      if (ids.length > 0 && window.vuplex) {
        const fetchData = async () => {
          const response = await fetchDataFn(ids, pastDate);
          if (response.status === 200) {
            sendMessage("DataManager", messageType, JSON.stringify(response.data));
          }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 60000);
        return () => clearInterval(intervalId);
      }
    }, [ids, fetchDataFn, messageType, pastDate, window]);
  };

  useDataFetcher(tagsIds, "SetTagsData", getTagData);
  useDataFetcher(expressionIds, "SetExpressionsData", getExpressionData);

  const updateLabels = async () => {
    if (window.vuplex) {
      const LabelsResponse = await getLabelsMeta();
      if (LabelsResponse.status === 200) {
        setAllLabels(LabelsResponse.data);
      }
      window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
    }
  };

  useEffect(() => {
    setRenderBubble(true);
  }, [allBubbles]);

  useEffect(() => {
    if (window.vuplex && rerenderBubbleData) {
      sendBubbleData(false);
      setRenderBubbleData(false);
    }
  }, [rerenderBubbleData, sendBubbleData, window.vuplex]);

  const resumeUnity = () => {
    if (isLoaded) {
      sendMessage("__ReactInputBlocker", "SetBlockState", 0);
      setIsMovementDisabled(0);
    }
  };

  const pauseUnity = () => {
    sendMessage("__ReactInputBlocker", "SetBlockState", 1);
    setIsMovementDisabled(1);
  };

  function bubbleCloseHandler() {
    setBubbleModalOpen(false);
    setBubblePopUp(null);
    setbubbleAllDetails(null);
    resumeUnity();
  }

  useEffect(() => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
    }
  }, [window.vuplex]);

  useEffect(() => {
    if (window.vuplex && rerenderBubble) {
      sendBubbleData(true);
      setRenderBubble(false);
    }
  }, [rerenderBubble, sendBubbleData, window.vuplex]);

  useEffect(() => {
    setRenderBubbleData(true);
  }, [units]);

  useEffect(() => {
    if (window.vuplex) {
      if (allNotes) {
        const notesCollection = allNotes.map((eachNote: any) => {
          const { id, x, y, z, header, note } = eachNote;
          return { id, x, y, z, header, note };
        });
        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(notesCollection)] }));
      } else {
        window.vuplex.postMessage(JSON.stringify({ object: "MainNote", type: "ProcessHub.DynamicNote.DynamicNoteController", method: "SetNotesList", arguments: [JSON.stringify(allNotes)] }));
      }
    }
  }, [allNotes, window.vuplex]);

  useEffect(() => {
    if (window.vuplex) {
      if (allLabels) {
        const LabelsCollection = allLabels.map((eachLabel: any) => {
          const { id, x, y, z, prefabId, prefabParentId, name } = eachLabel;
          return { id, x, y, z, prefabId, prefabParentId, name };
        });
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(LabelsCollection)] }));
      } else {
        window.vuplex.postMessage(JSON.stringify({ object: "MainLabel", type: "ProcessHub.DynamicLabel.DynamicLabelController", method: "SetLabelsList", arguments: [JSON.stringify(allLabels)] }));
      }
    }
  }, [allLabels, window.vuplex]);

  useEffect(() => {
    if (window.vuplex) {
      if (picturesDetails.length > 0) {
        window.vuplex.postMessage(
          JSON.stringify({
            object: "__ScansManager__",
            type: "Scans.ScansManager",
            method: "SetCamerasData",
            arguments: [JSON.stringify(picturesDetails)],
          })
        );
      }
    }
  }, [picturesDetails, window.vuplex]);

  const useUnityDataEffect = (selectedData: any, apiCall: any, method: any) => {
    useEffect(() => {
      if (selectedData) {
        const fetchData = async () => {
          const response = await apiCall(selectedData, pastDate);
          const processedData = response.data;
          const message = JSON.stringify({ object: "DataManager", type: "DataManager", method, arguments: [JSON.stringify(processedData)] });
          window.vuplex.postMessage(message);
        };

        fetchData();

        const intervalId = setInterval(fetchData, 15000);

        return () => {
          clearInterval(intervalId);
        };
      }
    }, [selectedData, method, pastDate]);
  };

  useUnityDataEffect(tagsIds, getTagData, "SetTagsData");
  useUnityDataEffect(expressionIds, getExpressionData, "SetExpressionsData");

  useEffect(() => {
    if (selectedPointCloudId !== null) {
      const getPointCloudPics = async () => {
        if (selectedPointCloudId) {
          const response = await getPointCloudImages(selectedPointCloudId);
          if (response.status === 200) {
            setPicturesDetails(response.data);
          }
        }
      };
      getPointCloudPics();
    }
  }, [selectedPointCloudId]);

  function createBubble(arr: number[]) {
    const bubbleDetails = {
      x: arr[0],
      y: arr[1],
      z: arr[2],
      unitId: null,
      equipmentId: null,
    };
    setBubblePopUp(bubbleDetails);
    setBubbleModalOpen(true);
    setBubbleId(null);
  }

  function createNote(arr: any, mode: 'regular' | 'withDescription') {
    if (mode === 'regular') {
      const noteDetails = {
        x: arr[0],
        y: arr[1],
        z: arr[2],
      };
      setNotePopup(noteDetails);
      setNoteId(null);
      setNoteModalOpen(true);
    }
    if (mode === 'withDescription') {
      const submitNote = async () => {
        const formData = new FormData();
        formData.append("unityNote.Model.header", arr.title);
        formData.append("unityNote.Model.note", arr.description);
        formData.append("unityNote.Model.x", arr.x.toString());
        formData.append("unityNote.Model.y", arr.y.toString());
        formData.append("unityNote.Model.z", arr.z.toString());
        await crateNoteApiCall(formData);
        noteCloseHandler();
        updateNotes();
      };
      submitNote();
    }
  }

  function createLabel(arr: number[]) {
    const LabelDetails = {
      x: arr[0],
      y: arr[1],
      z: arr[2],
    };
    setLabelPopup(LabelDetails);
    setLabelId(null);
    setLabelModalOpen(true);
  }

  async function updateBubblePosition(bubbles: any) {
    if (bubbles) {
      const data = JSON.parse(bubbles);
      const response: any = await apiUpdateBubblePosition(data);
      if (response.status === 200) {
        refreshUnityData();
      }
    }
  }

  function configureBubbleHandler(bubbleId: any) {
    if (bubbleId) {
      setBubblePopUp(null);
      setBubbleModalOpen(true);
      setBubbleId(bubbleId);
    }
  }

  function openNote(noteId: number) {
    setNotePopup(null);
    setNoteId(noteId);
    setNoteModalOpen(true);
  }

  function openLabel(LabelId: number) {
    setLabelPopup(null);
    setLabelId(LabelId);
    setTimeout(() => {
      setLabelModalOpen(true);
    }, 500);
  }


  async function updateLabelPosition(labels: any) {
    if (labels) {
      const response = await updateLabelPos(labels);
      if (response.status === 200) {
        const labelsMetaResponse = await getLabelsMeta();
        if (labelsMetaResponse.status === 200) {
          setAllLabels(labelsMetaResponse.data);
        }
      }
    }
  }

  const tagsAndBubbleConfigHandler: any = useCallback(
    async (bubbleId: number, equipmentId: number, type: string) => {
      const bubbleTagDetails: any = await TagExpressionHandler(
        bubbleId,
        equipmentId,
        type,
        "tag"
      );

      if (type === "unconfigured") {
        setSelectedUnit(null);
        configureBubbleHandler(bubbleId);
      } else {
        setbubbleAllDetails({ bubbletype: type, unitId: bubbleTagDetails.unitId, equipmentId: type == "equipment" ? equipmentId : null });
        setSelectedUnit(bubbleTagDetails.unitId);
        setBubbleDetails(bubbleTagDetails.details);
        if (
          bubbleTagDetails.collections &&
          bubbleTagDetails.collections.length > 0
        ) {
          setChartData(bubbleTagDetails.collections);
          setModalOpen(true);
          setModalLoader(false);
          setBubbleId(bubbleId);
        } else {
          configureBubbleHandler(bubbleId);
        }
      }
    },
    [getTagsInfo, getEquipmentInfo, configureBubbleHandler, equipments]
  );

  async function expressionsHandler(bubbleId: number, assertId: number, type: string) {
    const bubbleExpressionDetails: any = await TagExpressionHandler(
      bubbleId,
      assertId,
      type,
      "expression"
    );
    setSelectedUnit(bubbleExpressionDetails.unitId);
    setBubbleDetails(bubbleExpressionDetails.details);

    setbubbleAllDetails({ bubbletype: type, unitId: bubbleExpressionDetails.unitId, equipmentId: type == "equipment" ? assertId : null });
    if (
      bubbleExpressionDetails.collections &&
      bubbleExpressionDetails.collections.length > 0
    ) {
      setChartData(bubbleExpressionDetails.collections);
      setModalOpen(true);
      setModalLoader(false);
      setBubbleId(bubbleId);
    } else {
      configureBubbleHandler(bubbleId);
    }
  }

  const noteCloseHandler = useCallback(() => {
    setNoteModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const LabelCloseHandler = useCallback(() => {
    setLabelModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
    resumeUnity();
  }, [resumeUnity]);

  const handleModalLoader = useCallback(() => {
    pauseUnity();
    setModalLoader(false);
  }, [pauseUnity]);

  const ticketTagsHandler = useCallback((tagId: number) => {
    updateTicketTags((state) => {
      const newList = [...state];
      newList.push(tagId);
      return newList;
    });
  }, []);

  const onLeftArrowClick = (data: any, position: 'left' | 'right', size: 'regular' | 'small') => {
    const newItemInfo = getItemByIndex(picturesDetails, data.index - 1);
    if (newItemInfo) {
      size === 'small' ?
        addItemToPosition(position === 'left' ? 'bottomLeft' : 'bottomRight', {
          type: 'preview',
          data: {
            fileSrc: newItemInfo.url,
            fileName: newItemInfo.fileName,
            fileType: getFileExtension(newItemInfo.url),
            index: data.index - 1,
          },
        }) :
        setPointCloudPicData({
          fileSrc: newItemInfo.url, fileName: newItemInfo.fileName, index: data.index - 1
        });
    }
  };

  const onRightArrowClick = (data: any, position: 'left' | 'right', size: 'regular' | 'small') => {
    const newItemInfo = getItemByIndex(picturesDetails, data.index + 1);
    if (newItemInfo) {
      size === 'small' ?
        addItemToPosition(position === 'left' ? 'bottomLeft' : 'bottomRight', {
          type: 'preview',
          data: {
            fileSrc: newItemInfo.url,
            fileName: newItemInfo.fileName,
            fileType: getFileExtension(newItemInfo.url),
            index: data.index + 1,
          },
        }) :
        setPointCloudPicData({
          fileSrc: newItemInfo.url, fileName: newItemInfo.fileName, index: data.index + 1
        });
    }
  };

  useEffect(() => {
    if (isLoaded) {
      setShowLogo(true);
      setTimeout(() => {
        setShowLogo(false);
      }, 5000);
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!isModalOpen) {
      setPictureLoading(false);
      // setPointCloudPicId(null);
      setRawPicUrl(null);
      setIsMovementDisabled(0);
    }
  }, [isModalOpen]);

  const getWidgetsInfo = async () => {
    const widgetsData: any = await getWidgetsData();
    const widgetsMeta: any = await getWidgetsMeta();
    if (widgetsData.status === 200) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetData",
            arguments: [JSON.stringify(widgetsData.data)]
          }
        )
      );
    }
    if (widgetsMeta.status === 200) {
      window.vuplex.postMessage(
        JSON.stringify(
          {
            object: "MainWidget",
            type: "ProcessHub.DynamicWidget.DynamicWidgetController",
            method: "SetWidgetMeta",
            arguments: [JSON.stringify(widgetsMeta.data)]
          }
        )
      );
    }
  };


  const refreshUnityData = async () => {
    const data = await getData(true);
    setBubblesMeta(data.BubblesMeta);
    setAllBubbles(data.BubblesData);
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  };

  useEffect(() => {
    if (window.vuplex) {
      sendMessage("MainNote", "SetNotesList", JSON.stringify(allNotes));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleList", arguments: [JSON.stringify(bubblesMeta)] }));
      window.vuplex.postMessage(JSON.stringify({ object: "MainBubble", type: "ProcessHub.DynamicBubble.DynamicBubbleController", method: "SetBubbleData", arguments: [JSON.stringify(allBubbles)] }));
    }
  }, [allBubbles, bubblesMeta, allNotes]);

  const handleConfigClick = () => {
    setSelectedWidget(widgetForBubbleId);
  };

  const sendStateToUnity = (method: string, readyArguments: any) => {
    if (window.vuplex) {
      window.vuplex.postMessage(JSON.stringify({
        object: 'ReactUIManager',
        type: 'ReactUIManager',
        method: method,
        arguments: [JSON.stringify(readyArguments)]
      }));
    }
  };



  function addMessageListener() {
    window.vuplex.addEventListener("message", async function (event: { data: any }) {
      const tjson = event.data;
      const parsedInfo = JSON.parse(tjson);
      if (parsedInfo.methodName === 'TriggerOnLeftClick') {
        const tagsAndBubblesInfo = JSON.parse(parsedInfo.message);
        setbubbleAllDetails(tagsAndBubblesInfo);
        setWidgetForBubbleId(tagsAndBubblesInfo.Id);
        setChartType(tagsAndBubblesInfo.Type);
        tagsAndBubbleConfigHandler(tagsAndBubblesInfo.Id, tagsAndBubblesInfo.AssertId, tagsAndBubblesInfo.AssertType);
      }
      if (parsedInfo.methodName === 'TriggerOnRightClick') {
        const expressions = JSON.parse(parsedInfo.message);
        setbubbleAllDetails(expressions);
        expressionsHandler(expressions.Id, expressions.AssertId, expressions.AssertType);
      }
      if (parsedInfo.methodName === 'NewBubbleAdded') {
        const bubblePoints = JSON.parse(parsedInfo.message);
        createBubble(bubblePoints);
      }
      if (parsedInfo.methodName === 'UpdateBubblePosition') {
        const newBubblePosition = JSON.parse(parsedInfo.message);
        updateBubblePosition(newBubblePosition);
      }
      if (parsedInfo.methodName === 'NewNoteAdded') {
        const newNote = JSON.parse(parsedInfo.message);
        createNote(newNote, 'regular');
      }
      if (parsedInfo.methodName === 'openNote') {
        const noteToOpen = JSON.parse(parsedInfo.message);
        openNote(noteToOpen);
      }
      if (parsedInfo.methodName === 'NewLabelAdded') {
        const newLabel = JSON.parse(parsedInfo.message);
        createLabel(newLabel);
      }
      if (parsedInfo.methodName === 'openLabel') {
        const labelToOpen = JSON.parse(parsedInfo.message);
        openLabel(labelToOpen);
      }
      if (parsedInfo.methodName === 'UpdateLabelPosition') {
        const updatedLabel = JSON.parse(parsedInfo.message);
        updateLabelPosition(updatedLabel);
      }
      if (parsedInfo.methodName === 'GetCamerasByScanID') {
        const cameraId = JSON.parse(parsedInfo.message);
        setSelectedPointCloudId(Number(cameraId));
      }
      if (parsedInfo.methodName === 'UnityOpenImageRequest') {
        const pictureData = JSON.parse(parsedInfo.message);
        if (pointCloudPicData.fileSrc === '') {
          setRawPicUrl(pictureData.FileUrl);
          setIsMovementDisabled(1);
          setIsModalOpen(true);
        }
      }
      if (parsedInfo.methodName === 'UnityTagsRequest') {
        if (parsedInfo.message.length > 0) {
          const ids = JSON.parse(parsedInfo.message);
          setTagsIds(ids);
        }
      }
      if (parsedInfo.methodName === 'UnityExpressionsRequest') {
        if (parsedInfo.message.length > 0) {
          const ids = JSON.parse(parsedInfo.message);
          setExpressionsIds(ids);
        }
      }
      if (parsedInfo.methodName === 'NewWidgetAdded') {
        if (parsedInfo.message.length > 0) {
          const coordinates = JSON.parse(parsedInfo.message);
          setSelectedWidget(null);
          setWidgetCoordinates(coordinates);
          setWidgetModalMode('create');
        }
      }
      if (parsedInfo.methodName === 'OpenWidget') {
        if (parsedInfo.message.length > 0) {
          const id = JSON.parse(parsedInfo.message);
          setSelectedWidget(id);
        }
      }
      if (parsedInfo.methodName === 'UpdateWidgetPosition') {
        if (parsedInfo.message.length > 0) {
          const updatedWidgetPosition = JSON.parse(parsedInfo.message);
          setWidgetPositionUpdate(updatedWidgetPosition);
        }
      }
      if (parsedInfo.methodName === 'DeleteWidget') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'widget', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteBubble') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'bubble', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteLabel') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'label', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'DeleteNote') {
        if (parsedInfo.message.length > 0) {
          const itemToDelete = JSON.parse(parsedInfo.message);
          setItemToDelete({ item: 'note', id: itemToDelete });
        }
      }
      if (parsedInfo.methodName === 'NewNoteWithDetailsAdded') {
        if (parsedInfo.message.length > 0) {
          const noteInfo = JSON.parse(parsedInfo.message);
          createNote(noteInfo, 'withDescription');
        }
      }
    });
  }

  useEffect(() => {
    if (itemToDelete && itemToDelete.id !== null) {  // Check if itemToDelete and id are valid
      const removeItem = async () => {
        const itemsConfig: Record<string, (id: any) => Promise<any>> = {
          widget: deleteWidget,
          bubble: deleteBubble,
          label: deleteLabel,
          note: deleteNote
        };

        const api = itemsConfig[itemToDelete.item];
        if (api) {
          try {
            const response = await api(itemToDelete.id);
            if (response.status === 200) {
              setItemToDelete({ item: '', id: null });
            } else {
              console.error(`${itemToDelete.item} deletion failed with status: ${response.status}`);
            }
          } catch (error) {
            console.error(`Error deleting ${itemToDelete.item}:`, error);
          }
        } else {
          console.warn(`No delete function found for item type: ${itemToDelete.item}`);
        }
      };

      removeItem();
    }
  }, [itemToDelete]);

  useEffect(() => {
    if (widgetPositionUpdate !== null) {
      const updateWidgetPosotionApi = async () => {
        const response = await updateWidgetPosition(widgetPositionUpdate);
        if (response.status === 200) {
          setWidgetPositionUpdate(null);
        }
        else {
          console.error('widget not updated');
        }
      };
      updateWidgetPosotionApi();
    }
  }, [widgetPositionUpdate]);

  useEffect(() => {
    if (window.vuplex) {
      addMessageListener();
    }
    else {
      window.addEventListener('vuplexready', addMessageListener);
    }
  }, []);

  useEffect(() => {
    if (widgetCoordinates.length > 0) {
      setWidgetData((prev: any) => ({
        ...prev,
        x: widgetCoordinates[0],
        y: widgetCoordinates[1],
        z: widgetCoordinates[2]
      }));
    }
  }, [widgetCoordinates]);

  const getFileData = async (id: any) => {
    const response = await getFileByUniqueId(id);
    if (response.status === 200) {
      return response.data;
    }
  };

  const onFileClick = async (file: any) => {
    const { uniqueId, fileName } = file;
    const data = await getFileData(uniqueId);
    setPreviewData({
      uniqueId, fileName, data
    });
    setIsModalOpen(true);
  };

  const togglePins = () => {
    setShowPins((prev) => !prev);
  };

  useEffect(() => {
    const messageHandler = async (event: { data: any }) => {
      const tjson = event.data;
      const parsedInfo = JSON.parse(tjson);
      if (parsedInfo.methodName === 'AddDistanceAndArea') {
        const distanceAndAreaItem = JSON.parse(parsedInfo.message);
        setDistanceAndArea((prev: any) => [...prev, distanceAndAreaItem]);
        if (distanceAndAreaItem && distanceAndAreaItem.id) {
          setSelectedFigure(distanceAndAreaItem.id);
        }
      }
      if (parsedInfo.methodName === 'AddVolume') {
        const volumeItem = JSON.parse(parsedInfo.message);
        setVolume((prev) => [...prev, volumeItem]);
        if (volumeItem && volumeItem.id) {
          setSelectedFigure(volumeItem.id);
        }
      }
      if (parsedInfo.methodName === 'AddPoint') {
        const newPointData = JSON.parse(parsedInfo.message);
        addPoint(newPointData, setDistanceAndArea);
      }
      if (parsedInfo.methodName === 'AddVolumeValue') {
        const newVolumeValue = JSON.parse(parsedInfo.message);
        addPoint(newVolumeValue, setVolume);
      }
      if (parsedInfo.methodName === 'SetFigureValue') {
        const newFigureValue = JSON.parse(parsedInfo.message);
        setValue({ type: selectedTab, payload: newFigureValue });
      }
      if (parsedInfo.methodName === 'UpdatePoint') {
        const updatedPointData = JSON.parse(parsedInfo.message);
        updatePointCoordinates(updatedPointData);
      }
    };

    if (window.vuplex) {
      window.vuplex.addEventListener("message", messageHandler);
    } else {
      window.addEventListener("vuplexready", () => {
        window.vuplex?.addEventListener("message", messageHandler);
      });
    }

    return () => {
      if (window.vuplex) {
        window.vuplex.removeEventListener("message", messageHandler);
      }
    };
  }, [selectedTab]);

  useEffect(() => {
    if (minifiedImgPreviewData.leftPanelId.fileSrc !== '') {

      addItemToPosition('bottomLeft', {
        type: 'preview',
        data: {
          fileSrc: minifiedImgPreviewData.leftPanelId.fileSrc || null,
          fileName: minifiedImgPreviewData.leftPanelId.fileName || '',
          fileType: getFileExtension(minifiedImgPreviewData.leftPanelId.fileSrc || ''),
        },
      });

      const controller = new AbortController();
      const signal = controller.signal;

      return () => {
        controller.abort();
      };
    }
  }, [minifiedImgPreviewData.leftPanelId]);

  useEffect(() => {
    if (minifiedImgPreviewData.rightPanelId.fileSrc !== '') {
      addItemToPosition('bottomRight', {
        type: 'preview',
        data: {
          fileSrc: minifiedImgPreviewData.rightPanelId.fileSrc,
          fileName: minifiedImgPreviewData.rightPanelId.fileName || '',
          fileType: getFileExtension(minifiedImgPreviewData.rightPanelId.fileSrc || ''),
        },
      });

      const controller = new AbortController();
      const signal = controller.signal;

      // !minifiedImgPreviewData.rightPanelId.fileName && fetchPictureData({
      //   id: minifiedImgPreviewData.rightPanelId.id.toString(),
      //   signal,
      //   onSuccess: (rawData) => {
      //     addItemToPosition('bottomRight', {
      //       type: 'preview',
      //       data: {
      //         id: minifiedImgPreviewData.rightPanelId.id,
      //         data: rawData.data,
      //         fileName: rawData.fileName,
      //         fileType: getFileExtension(rawData.fileName),
      //       },
      //     });
      //   },
      //   onError: (error) => {
      //     console.log(error);
      //   },
      // });

      return () => {
        controller.abort();
      };
    }
  }, [minifiedImgPreviewData.rightPanelId]);

  const onLeftMinifyClick = (mode: string) => {
    if (mode === 'note') {
      addItemToPosition('bottomLeft', { type: 'note', data: { popupNoteId, notePopup } });
      setNoteModalOpen(false);
    }

    if (mode === 'doc') {
      addItemToPosition('bottomLeft', {
        type: 'doc',
        data: {
          id: previewData.uniqueId,
          data: previewData.data,
          fileName: previewData.fileName,
          fileType: getFileExtension(previewData.fileName),
        },
      });
      setIsModalOpen(false);
    }

    if (mode === 'widget') {
      addItemToPosition('bottomLeft', { type: 'widget', data: { WebGLContext, bubbleAllDetails, chartData, name: bubbleDetails?.name } });
      setModalOpen(false);
    }

    if (mode === 'preview') {
      if (pointCloudPicData.fileSrc) {
        addItemToPosition('bottomLeft', {
          type: 'preview',
          data: {
            fileSrc: pointCloudPicData.fileSrc,
            fileName: pointCloudPicData.fileName,
            fileType: getFileExtension(pointCloudPicData.fileSrc),
            index: pointCloudPicData.index
          },
        });
      } else {
        updateLeftPanel({
          fileSrc: '',
          fileName: '',
          fileType: '',
        });
        addItemToPosition('bottomLeft', {
          type: 'preview',
          data: {
            id: previewData.uniqueId,
            data: previewData.data,
            fileName: previewData.fileName,
            fileType: getFileExtension(previewData.fileSrc),
          },
        });
      }
      setIsModalOpen(false);
    }
  };

  const onRightMinifyClick = (mode: string) => {
    if (mode === 'note') {
      addItemToPosition('bottomRight', { type: 'note', data: { popupNoteId, notePopup } });
      setNoteModalOpen(false);
    }

    if (mode === 'widget') {
      addItemToPosition('bottomRight', { type: 'widget', data: { WebGLContext, bubbleAllDetails, chartData, name: bubbleDetails?.name } });
      setModalOpen(false);
    }

    if (mode === 'doc') {
      addItemToPosition('bottomRight', {
        type: 'doc',
        data: {
          id: previewData.uniqueId,
          data: previewData.data,
          fileName: previewData.fileName,
          fileType: getFileExtension(previewData.fileName),
        },
      });
      setIsModalOpen(false);
    }

    if (mode === 'preview') {
      if (pointCloudPicData.fileSrc) {
        addItemToPosition('bottomRight', {
          type: 'preview',
          data: {
            fileSrc: pointCloudPicData.fileSrc,
            fileName: pointCloudPicData.fileName,
            fileType: getFileExtension(pointCloudPicData.fileSrc),
            index: pointCloudPicData.index
          },
        });
      } else {
        updateRightPanel({
          fileSrc: '',
          fileName: '',
          fileType: '',
        });
        addItemToPosition('bottomRight', {
          type: 'preview',
          data: {
            id: previewData.uniqueId,
            data: previewData.data,
            fileName: previewData.fileName,
            fileType: getFileExtension(previewData.fileSrc),
          },
        });
      }
      setIsModalOpen(false);
    }
  };

  const onFullScreenClick = async (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc', data: any) => {

    if (mode === 'note') {
      setNoteId(data);
      setNoteModalOpen(true);
    }

    if (mode === 'preview') {
      if (data) {
        setIsModalOpen(true);
        setRawPicUrl(data.fileSrc);
      }
    }

    if (mode === 'doc') {
      const result = findItemByUUID(minifiedMenuItems, data);
      if (result) {
        setPreviewData({ uniqueId: data, fileName: result.fileName, data: result.data });
        setIsModalOpen(true);
      }
    }

    if (mode === 'widget') {
      setChartData(data.chartData);
      setbubbleAllDetails({ bubbletype: data.widgetData.bubbletype, unitId: data.widgetData.unitId, equipmentId: data.widgetData.equipmentId });
      setModalOpen(true);
    }
    return null;
  };

  const genModalItems = (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc' | 'pins' | 'measurements' | 'aiChat', data: any, position: 'left' | 'right') => {
    if (mode === 'measurements') {
      return (
        <UnityMeasurements />
      );
    }
    if (mode === 'note') {
      return (
        <div className="w-full h-full opacity-95">
          <Note
            size="small"
            noteId={data.popupNoteId}
            onFullScreenClick={onFullScreenClick}
            onLeftMinifyClick={() => null}
            onRightMinifyClick={() => null}
            onFileClick={onFileClick}
            noteDetails={data.notePopup}
            closeHandler={() => removeMinifiedTab(mode, position)}
            updateNotes={updateNotes}
            pauseUnity={pauseUnity}
            noteFormConfig={noteFormConfig}
            hooks={allHooks}
          />
        </div>
      );
    }
    if (mode === 'doc') {
      return (
        <PreviewFiles
          closeHandler={() => removeMinifiedTab(mode, position)}
          data={data.data}
          position={position}
          fileName={data.fileName}
          picId={data.id}
          size='small'
          onLeftMinifyClick={onLeftMinifyClick}
          onRightMinifyClick={onRightMinifyClick}
          onFullScreenClick={onFullScreenClick}
          type='unity'
          fileType={data.fileType}
          setIsModalOpen={setIsModalOpen}
          onLeftArrowClick={onLeftArrowClick}
          onRightArrowClick={onRightArrowClick}
        />
      );
    }
    if (mode === 'preview') {
      return (
        <div className="w-full h-full"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <PreviewFiles
            closeHandler={() => removeMinifiedTab(mode, position)}
            data={data}
            position={position}
            fileName={data.fileName}
            picId={data.id}
            size='small'
            onLeftMinifyClick={onLeftMinifyClick}
            onRightMinifyClick={onRightMinifyClick}
            onFullScreenClick={onFullScreenClick}
            type='unity'
            fileType={data.fileType}
            setIsModalOpen={setIsModalOpen}
            onLeftArrowClick={onLeftArrowClick}
            onRightArrowClick={onRightArrowClick}
          />
        </div>
      );
    }
    if (mode === 'widget') {
      return (
        <div className="w-full h-full">
          <ChartsContainer
            setPreviewData={setPreviewData}
            setIsSpecialModalOpen={setIsModalOpen}
            closeHandler={() => removeMinifiedTab(mode, position)}
            size="small"
            onLeftMinifyClick={onLeftMinifyClick}
            onRightMinifyClick={onRightMinifyClick}
            name="Widget"
            setModalOpen={setModalOpen}
            onFullScreenClick={onFullScreenClick}
            WebGLContext={WebGLContext}
            bubbleAllDetailsData={data.bubbleAllDetails}
            chartRawData={data.chartData}
            handleConfigClick={handleConfigClick}
            chartType={chartType}
            hooks={allHooks}
            unityChartsContainerConfig={unityChartsContainerConfig}
            theme="default"
          />
        </div>
      );
    }
    if (mode === 'pins' && unityPins.length > 0) {
      return (
        <div className="w-full h-full max-h-full pb-12 bg-dark/65 overflow-hidden overflow-y-auto">
          <div className="p-2 flex flex-wrap gap-2 overflow-y-auto">
            {unityPins.map((pin: any, index: number) => (
              <Pin key={pin.id || index} data={pin} unityPin fixedWidth={false} hooks={allHooks} />
            ))}
          </div>
        </div>
      );
    }
    if (mode === 'aiChat') {
      return (
        <div
          className="h-full w-full bg-gray/70"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
        >
          <AiChat setIsMovementDisabled={setIsMovementDisabled} />
        </div>
      );
    }
    return null;
  };

  return (
    <WebGLContext.Provider
      value={{
        resumeUnity,
        pauseUnity,
        chartData,
        bubbleDetails,
        handleModalLoader,
        handleCloseModal,
        modalOpen,
        modalLoader,
        ticketTags,
        ticketTagsHandler,
        popupBubbleId,
        configureBubbleHandler,
        chartType,
        setChartType,
        refreshUnityData,
        bubbleAllDetails
      }}
    >
      {modalOpen && chartData && <ChartsContainer setPreviewData={setPreviewData} setIsSpecialModalOpen={setIsModalOpen} size="regular" closeHandler={() => null} bubbleAllDetailsData={null} chartRawData={null} name="" onFullScreenClick={() => null} onRightMinifyClick={onRightMinifyClick} onLeftMinifyClick={onLeftMinifyClick} setModalOpen={setModalOpen} WebGLContext={WebGLContext} handleConfigClick={handleConfigClick} chartType={chartType} hooks={allHooks} unityChartsContainerConfig={unityChartsContainerConfig} theme="default" />}

      {widgetModalMode !== 'none' && <Widget
        units={units}
        equipments={equipments}
        widgetData={widgetData}
        setWidgetData={setWidgetData}
        widgetModalMode={widgetModalMode}
        setWidgetModalMode={setWidgetModalMode}
        unityWidgetConfig={unityWidgetConfig}
        hooks={allHooks}
      />}

      {noteModalOpen && (
        <div className="fixed inset-0 z-20 w-full h-screen"
          style={{
            // cursor: "not-allowed",
            backgroundColor: "transparent", // optional, could also be rgba(0,0,0,0.0)
          }}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}>
          <div
            className=
            "h-full absolute z-30 inset-0 w-full bg-black/70"
          />

          <div className="top-1/2 w-full h-auto rounded-md z-40 absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:max-w-[650px] max-h-[80vh]">
            <Note
              size="regular"
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={() => null}
              noteId={popupNoteId}
              onFileClick={onFileClick}
              noteDetails={notePopup}
              closeHandler={noteCloseHandler}
              updateNotes={updateNotes}
              pauseUnity={pauseUnity}
              noteFormConfig={noteFormConfig}
              hooks={allHooks}
            />
          </div>
        </div>
      )}

      {LabelModalOpen && (
        <Label
          LabelId={popupLabelId}
          LabelDetails={LabelPopup}
          closeHandler={LabelCloseHandler}
          updateLabels={updateLabels}
          pauseUnity={pauseUnity}
          resumeUnity={resumeUnity}
          allLabels={allLabels}
          LabelConfig={labelConfig}
        />
      )}

      {pointCloudPicData.fileSrc && isModalOpen && (
        <div className="h-screen w-full flex items-center justify-center align-middle relative bg-black/70 z-20"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="relative">
            <PreviewFiles
              data={pointCloudPicData}
              fileName={pointCloudPicData.fileName}
              size='regular'
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={onFullScreenClick}
              type='unity'
              fileType={getFileExtension(pointCloudPicData.fileSrc)}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              onLeftArrowClick={onLeftArrowClick}
              onRightArrowClick={onRightArrowClick}
            />
          </div>
        </div>
      )}

      {previewData.uniqueId !== '' && isModalOpen &&
        <div className="h-screen w-full flex items-center justify-center align-middle relative"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="relative z-50">
            <PreviewFiles
              data={previewData.data}
              fileName={previewData.fileName}
              size='regular'
              onLeftMinifyClick={onLeftMinifyClick}
              onRightMinifyClick={onRightMinifyClick}
              onFullScreenClick={onFullScreenClick}
              type='unity'
              fileType={getFileExtension(previewData.fileName)}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              onLeftArrowClick={onLeftArrowClick}
              onRightArrowClick={onRightArrowClick}
            />
          </div>
        </div>
      }

      <div className="relative">
        <div id="unity-container">
          <SplashScreen
            open={!isLoaded || showLogo}
            logo={true}
            status={loadingStatus}
          />
          <Unity
            unityProvider={unityProvider}
            className="unityApp"
            style={{
              width: "100vw",
              height: "100vh",
              visibility: isLoaded || showLogo ? "visible" : "hidden",
            }}
          />
        </div>
      </div>
      <div className="h-screen w-screen fixed bottom-0 left-0 z-50 overflow-hidden pointer-events-none">
        <div className="h-full w-full">
          <div className="pointer-events-auto">
            {minifiedMenuOpen && !editingMode && <MinifiedMenu genModalItems={genModalItems} allHooks={allHooks} visibilityParams={menuVisibilityParams} setVisibilityParams={setMenuVisibilityParams} />}
          </div>
        </div>
      </div>

      <UnityMenu TimelineShown={TimelineShown} isModalOpen={isModalOpen} />

    </WebGLContext.Provider>
  );
};

export default WebGL;